export default __webpack_public_path__ + "static/media/laundry2-beforeB-1440w.cefcb7df.webp";